/**
 * DotLottie preloader asset from `frontend/public/saae_preloader.lottie` (URL root).
 * @see https://vite.dev/guide/assets.html#the-public-directory
 */
export const SAAE_PRELOADER_DOTLOTTIE_URL = '/saae_preloader.lottie' as const;

/** Above sticky chrome, modals, toasts, dev nav, and stray high-z UI so the preloader always paints on top. */
export const SAAE_PRELOADER_Z_INDEX_CLASS = 'z-[100000]' as const;

/**
 * Square bound for the animation (~15% smaller than the prior 85vw / 560px cap).
 * `100%` keeps embedded hosts (cards, narrow columns) from overflowing.
 */
export const SAAE_PRELOADER_BOX_CLASS =
  'size-[min(72vw,476px,100%,calc(0.85*((100dvh-5.75rem)/2-2rem)))]' as const;
